function isDoggoMetaTrackingAllowed() {
  return (
    window.DoggoConsent &&
    typeof window.DoggoConsent.isMarketingAllowed === "function" &&
    window.DoggoConsent.isMarketingAllowed()
  );
}

function getDoggoCookieValue(name) {
  if (!isDoggoMetaTrackingAllowed()) return "";
  if (!name || !document.cookie) return "";

  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(name + "=") === 0) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }

  return "";
}

function getDoggoQueryParam(name) {
  var href = (window.location && window.location.href) || location.href || "";
  var queryStart = href.indexOf("?");
  if (queryStart === -1) return "";

  var query = href.substring(queryStart + 1).split("#")[0].split("&");
  for (var i = 0; i < query.length; i++) {
    var parts = query[i].split("=");
    if (decodeURIComponent(parts[0] || "") === name) {
      return decodeURIComponent((parts[1] || "").replace(/\+/g, " "));
    }
  }

  return "";
}

function getDoggoUtmParameters() {
  var utmParameters = new URLSearchParams();
  var currentParameters = new URLSearchParams((window.location && window.location.search) || "");

  currentParameters.forEach(function (value, key) {
    if (key.toLowerCase().indexOf("utm_") === 0) {
      utmParameters.append(key, value);
    }
  });

  return utmParameters.toString();
}

function getDoggoFbc() {
  if (!isDoggoMetaTrackingAllowed()) return "";
  var fbc = getDoggoCookieValue("_fbc");
  if (fbc) return fbc;

  var fbclid = getDoggoQueryParam("fbclid");
  if (!fbclid) return "";

  fbc = "fb.1." + Date.now() + "." + fbclid;
  document.cookie =
    "_fbc=" +
    encodeURIComponent(fbc) +
    "; path=/; max-age=7776000; SameSite=Lax";

  return fbc;
}

function hashDoggoMetaEventValue(value, seed) {
  var hash = seed;

  for (var index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 0x01000193);
  }

  return (hash >>> 0).toString(16).padStart(8, "0");
}

function normalizeDoggoMetaEventValue(value) {
  return String(value || "").trim().toLowerCase();
}

function buildDoggoMetaEventId(eventName, input) {
  input = input || {};

  if (input.entityId) {
    return "doggo:v1:" + eventName + ":" + input.entityId;
  }

  var canonicalValue = [
    eventName || "event",
    normalizeDoggoMetaEventValue(input.email),
    normalizeDoggoMetaEventValue(input.serviceType || input.content_category),
    input.actionTime || Date.now(),
  ].join("|");

  return (
    "doggo:v1:" +
    (eventName || "event") +
    ":" +
    hashDoggoMetaEventValue(canonicalValue, 0x811c9dc5) +
    hashDoggoMetaEventValue(canonicalValue, 0x9e3779b9)
  );
}

function getDoggoMetaFormEventInput(form) {
  var actionTime = (form && form.__doggoMetaActionTime) || Date.now();
  var email = "";
  var serviceType = "";

  if (form) {
    form.__doggoMetaActionTime = actionTime;

    var elements = form.elements || [];
    for (var index = 0; index < elements.length; index += 1) {
      var element = elements[index];
      var name = String(element.name || "").toLowerCase();

      if (name === "email" || name === "contact[email]" || element.type === "email") {
        email = element.value || "";
        break;
      }
    }

    var section = form.closest && form.closest(".dfb-section");
    var button = section && section.querySelector(".dfb-trigger-btn.my-custom-cart-button");
    serviceType = button ? String(button.getAttribute("leadType") || "").trim() : "";
  }

  return {
    email: email,
    serviceType: serviceType,
    actionTime: actionTime,
  };
}

function getDoggoMetaAttribution() {
  if (!isDoggoMetaTrackingAllowed()) return {};

  var attribution = {
    event_source_url: (window.location && window.location.href) || location.href,
    client_user_agent: navigator.userAgent || "",
  };
  var fbp = getDoggoCookieValue("_fbp");
  var fbc = getDoggoFbc();

  if (fbp) attribution.fbp = fbp;
  if (fbc) attribution.fbc = fbc;

  console.log(attribution);
  return attribution;
}

function trackDoggoMetaPixelEvent(eventName, payload, eventId) {
  if (!isDoggoMetaTrackingAllowed() || typeof fbq !== "function") return null;

  eventId = eventId || buildDoggoMetaEventId(eventName, payload);
  var enrichedPayload = Object.assign(
    {
      event_id: eventId,
    },
    payload,
    getDoggoMetaAttribution(),
  );

  fbq("track", eventName, enrichedPayload, { eventID: eventId });

  return {
    eventId: eventId,
    payload: enrichedPayload,
  };
}

function trackDoggoMetaPixelCustomEvent(eventName, payload, eventId) {
  if (!isDoggoMetaTrackingAllowed() || typeof fbq !== "function") return null;

  eventId = eventId || buildDoggoMetaEventId(eventName, payload);
  var enrichedPayload = Object.assign(
    {
      event_id: eventId,
    },
    payload,
    getDoggoMetaAttribution(),
  );

  fbq("trackCustom", eventName, enrichedPayload, { eventID: eventId });

  return {
    eventId: eventId,
    payload: enrichedPayload,
  };
}

window.doggoMetaAttribution = getDoggoMetaAttribution;

function setDoggoHiddenInput(form, name, value) {
  if (!form || !name || !value) return;

  var input = form.querySelector('input[name="' + name + '"]');
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    form.appendChild(input);
  }

  input.value = value;
}

function appendDoggoMetaFieldsToForm(form, eventId) {
  if (!isDoggoMetaTrackingAllowed()) return;

  var attribution = getDoggoMetaAttribution();
  var fields = {
    meta_event_id: eventId,
    meta_fbp: attribution.fbp,
    meta_fbc: attribution.fbc,
    meta_event_source_url: attribution.event_source_url,
    meta_client_user_agent: attribution.client_user_agent,
  };
  var useShopifyContactNames = !!form.querySelector('[name^="contact["]');

  Object.keys(fields).forEach(function (name) {
    setDoggoHiddenInput(form, name, fields[name]);

    if (useShopifyContactNames) {
      setDoggoHiddenInput(form, "contact[" + name + "]", fields[name]);
    }
  });
}

function prepareDoggoLeadMetaFields(form) {
  var eventInput = getDoggoMetaFormEventInput(form);
  if (!form) return buildDoggoMetaEventId("Lead", eventInput);

  var eventId = form.__doggoMetaLeadEventId || buildDoggoMetaEventId("Lead", eventInput);
  form.__doggoMetaLeadEventId = eventId;
  appendDoggoMetaFieldsToForm(form, eventId);

  return eventId;
}

function prepareDoggoSubmitApplicationMetaField(form) {
  if (!isDoggoMetaTrackingAllowed()) return;

  var eventInput = getDoggoMetaFormEventInput(form);
  if (!form) return buildDoggoMetaEventId("SubmitApplication", eventInput);

  var eventId =
    form.__doggoMetaSubmitApplicationEventId ||
    buildDoggoMetaEventId("SubmitApplication", eventInput);
  form.__doggoMetaSubmitApplicationEventId = eventId;
  setDoggoHiddenInput(form, "analyticsInfo.submitApplicationPixelEventId", eventId);

  return eventId;
}
